import { connect } from 'react-redux';
import { find } from '../../actions/base';
import UA from '../../components/sider/user-angent';

//export default connect(mapStateToProps, mapDispatchToProps)(UA);
export default connect()(UA);



// WEBPACK FOOTER //
// ./containers/sider/user-angent.js